/** @jsx jsx */

import { Box, Container, Divider, jsx, Text } from 'theme-ui';

import { Link } from 'gatsby';

export default function TalkBlock() {
  return (
    <Box sx={{ mt: 3, pt: 3 }}>
      <Container>
        <Divider sx={{ color: `dividerDim`, pt: 2 }} />
        <Box
          sx={{
            marginBottom: 3,
            display: `flex`,
            alignItems: `center`,
            mt: 4,
            pt: 4,
            justifyContent: `space-between`,
            '@media screen and (max-width: 720px)': {
              flexDirection: `column`,
              alignItems: `flex-start`,
              justifyContent: `flex-start`,
            },
          }}
        >
          <Box>
            <Text as="h3" variant="sectionTitle">
              Let&apos;s start talking
            </Text>
            <Box sx={{ mb: 5 }}>
              <Text
                as="h2"
                variant="titleDesc"
                sx={{
                  color: `dimText`,
                  lineHeight: `body`,
                  fontSize: 2,
                  fontWeight: 300,
                }}
              >
                Discuss your next project with us
              </Text>
            </Box>
          </Box>
          <Box sx={{ mt: 1, mr: 6 }}>
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to="https://calendly.com/muneef/15min"
              sx={{
                // color: `grays.9`,
                px: 5,
                py: 3,
                bg: `grays.9`,
                color: `grays.0`,
                // backgroundImage: `linear-gradient(to right, #16222A 0%, #3A6073  51%, #16222A  100%);`,
                '&:hover': {
                  bg: `grays.8`,
                  color: `grays.1`,
                  // backgroundImage: `linear-gradient(to right, #16222A 0%, #3A6073  51%, #16222A  100%);`,
                },
                // bg: `red`,
                // variant: `grays.`
              }}
            >
              <Text variant="talkButtonx">Schedule a call</Text>
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
